import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "What should I bring to my session?",
      answer: "Bring your beats, lyrics, and any reference tracks. We provide all recording equipment, headphones, and software. You can also upload files to our Google Drive before your session."
    },
    {
      question: "Is parking available?",
      answer: "Yes, street parking is available around the studio. We're also easily accessible via public transit."
    },
    {
      question: "Can I extend my recording time during the session?",
      answer: "Yes! If you need more time and the next slot is available, just let your engineer know. You can pay for the additional time at the start of the extension at the engineer's regular hourly rate."
    },
    {
      question: "What's your cancellation policy?",
      answer: "You can reschedule with 24-hour notice. Same-day cancellations result in forfeiture of your deposit. No-shows forfeit the full deposit."
    },
    {
      question: "Do you provide mixing and mastering?",
      answer: "Yes! We offer professional mixing and mastering services. Check our Services section for pricing and details."
    },
    {
      question: "Can I book multiple sessions at once?",
      answer: "Absolutely! Contact us for package deals on multiple sessions or full project bookings."
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept all major credit/debit cards online via Stripe for deposits. Balance can be paid with credit/debit cards, cash, or online upon arrival."
    },
    {
      question: "How far in advance should I book?",
      answer: "We recommend booking at least 2-3 days in advance, though we accept bookings as soon as 2 hours before the session (with a $20 last-minute fee)."
    },
    {
      question: "What happens after I book?",
      answer: "You'll receive a confirmation email with session details, Google Drive link to upload files, and an invoice. Your assigned engineer will also reach out to confirm and prepare for your session."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 bg-black">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-3">
            Frequently Asked <span className="bg-gradient-to-r from-purple-400 to-blue-400 bg-clip-text text-transparent">Questions</span>
          </h2>
          <p className="text-gray-400">
            Everything you need to know before booking
          </p>
        </div>

        {/* FAQ List */}
        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-purple-900/20 to-blue-900/20 backdrop-blur-sm border border-purple-500/20 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-purple-900/10 transition-colors"
              >
                <span className="font-semibold text-white pr-8">{faq.question}</span>
                {openIndex === index ? (
                  <ChevronUp className="text-purple-400 flex-shrink-0" size={20} />
                ) : (
                  <ChevronDown className="text-purple-400 flex-shrink-0" size={20} />
                )}
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-4">
                  <p className="text-gray-300 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
